import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listDiameters } from '../Api'

export default generateApiAction({
  baseType: Types.DIAMETERS.LIST,
  api: listDiameters,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/diameters/ListAction.js